import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateAfterHoursCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type AfterHoursState = void;

export const AFTER_HOURS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<AfterHoursState>>,
): ConditionType<AfterHoursState, Condition.AfterHours> => ({
  name: CONDITION_NAMES[Condition.AFTER_HOURS],
  description() {
    return t("Customer contacted after hours");
  },
  Details(props: ConditionTypeDetailsProps<AfterHoursState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.AFTER_HOURS };
  },
  valid() {
    return validateAfterHoursCondition({}).valid;
  },
});

export const AfterHoursDetails = React.memo(function AfterHoursDetails() {
  return null;
});
